import img2 from './../../../images/KID.jpg'
export const DATAS=[
    {
        id:1,
        userId:1,
        name:"Ali",
        profilePicture:img2,
    },

]